import { SquaresFour, Package, ChartBar, Factory, House, UsersThree, FileText, Users, Cpu, Ladder, Keyhole, Barricade, Waves, Lightning, CirclesThreePlus, HouseLine, AlignBottom, Paperclip, Percent, Barcode, UserFocus, Handshake, ClipboardText, Monitor, ChartBarHorizontal, Chalkboard, ClockCounterClockwise, FileCode, FileCloud, NotePencil, CreditCard, AddressBook, Printer, Receipt, ChatDots, IdentificationCard } from "@phosphor-icons/react";


const SidebarApi = [
    {
        title: 'Dashboard',
        icon: <SquaresFour size={30} weight="duotone" />,
        link: '/',
    },
    {
        title: 'Master',
        icon: <Package size={30} weight="duotone" />,
        link: '/Projects',
        childs: [
            {
                title: 'Project',
                icon: <ChartBar size={30} weight="duotone" />,
                link: '/Projects',
                subchilds: [
                    {
                        title: 'Create Building',
                        icon: <Factory size={30} weight="duotone" />,
                        link: '/Buildings'
                    },
                    {
                        title: 'Create Gala',
                        icon: <House size={30} weight="duotone" />,
                        link: '/Gala'
                    },
                    {
                        title: 'Create Investor',
                        icon: <UsersThree size={30} weight="duotone" />,
                        link: '/Investors',
                    },
                    {
                        title: 'Create LOI',
                        icon: <FileText size={30} weight="duotone" />,
                        link: '/Proposal'
                    },
                    {
                        title: 'Create Tenant',
                        icon: <Users size={30} weight="duotone" />,
                        link: '/TenantGala'
                    },
                ]
            },
            {
                title: 'Amenities',
                icon: <Cpu size={30} weight="duotone" />,
                link: '/FloorType',
                subchilds: [
                    {
                        title: 'Floor Type',
                        icon: <Ladder size={30} weight="duotone" />,
                        link: '/FloorType'
                    },
                    {
                        title: 'Permission Type',
                        icon: <Keyhole size={30} weight="duotone" />,
                        link: '/PermissionType'
                    },
                    {
                        title: 'Construct Type',
                        icon: <Barricade size={30} weight="duotone" />,
                        link: '/BuildingType'
                    },
                    {
                        title: 'Water Supply',
                        icon: <Waves size={30} weight="duotone" />,
                        link: '/WaterSupply'
                    },
                    {
                        title: 'Electric Supply',
                        icon: <Lightning size={30} weight="duotone" />,
                        link: '/ElectricityConnection'
                    },

                ]
            },
            {
                title: 'Others',
                icon: <CirclesThreePlus size={30} weight="duotone" />,
                link: '/Villages',
                subchilds: [
                    {
                        title: 'Villages',
                        icon: <HouseLine size={30} weight="duotone" />,
                        link: '/Villages'
                    },
                    {
                        title: 'City',
                        icon: <AlignBottom size={30} weight="duotone" />,
                        link: '/City'
                    },
                    {
                        title: 'Category of POC',
                        icon: <FileCode size={30} weight="duotone" />,
                        link: '/Poc'
                    },
                    {
                        title: 'Doc Name',
                        icon: <FileCloud size={30} weight="duotone" />,
                        link: '/DocumentsName'
                    },
                    {
                        title: 'Constitution',
                        icon: <Paperclip size={30} weight="duotone" />,
                        link: '/Constitution'
                    },
                    {
                        title: 'GST Rate',
                        icon: <Percent size={30} weight="duotone" />,
                        link: '/Gst'
                    },
                    {
                        title: 'Create HSN',
                        icon: <Barcode size={30} weight="duotone" />,
                        link: '/HSN'
                    },
                    {
                        title: 'Ownership Type',
                        icon: <UserFocus size={30} weight="duotone" />,
                        link: '/InvestorType'
                    },
                    {
                        title: 'Deal Basis On',
                        icon: <Handshake size={30} weight="duotone" />,
                        link: '/OnBasis'
                    },
                    {
                        title: 'Resale Reason',
                        icon: <ClipboardText size={30} weight="duotone" />,
                        link: '/ResellReason'
                    },
                    {
                        title: 'Bill Send From',
                        icon: <Printer size={30} weight="duotone" />,
                        link: '/BillSendFrom'
                    },
                ]
            },
        ]
    },
    {
        title: 'Display',
        icon: <Monitor size={30} weight="duotone" />,
        link: '/InvestorChart',
        childs: [
            // {
            //     title: 'Investor Details',
            //     icon: <IdentificationCard size={30} weight="duotone" />,
            //     link: '/SearchInvestors'
            // },
            {
                title: 'Chart of Investor',
                icon: <ChartBarHorizontal size={30} weight="duotone" />,
                link: '/InvestorChart'
            },
            {
                title: 'Vacant Status',
                icon: <Chalkboard size={30} weight="duotone" />,
                link: '/TenantAgeing'
            },
            {
                title: 'Tenant History',
                icon: <ClockCounterClockwise size={30} weight="duotone" />,
                link: '/TenantHistory'
            },
            {
                title: 'Resale History',
                icon: <ClockCounterClockwise size={30} weight="duotone" />,
                link: '/SoldHistory',
            }
        ]
    },
    {
        title: 'Sale Galas',
        icon: <HouseLine size={30} weight="duotone" />,
        link: '/SoldGalas',
    },
    {
        title: 'Accounts',
        icon: <AddressBook size={30} weight="duotone" />,
        link: '/Billing',
        childs: [
            {
                title: 'Billing',
                icon: <Printer size={30} weight="duotone" />,
                link: '/Billing'
            },
            {
                title: 'Generated bills',
                icon: <Printer size={30} weight="duotone" />,
                link: '/Generatedbills'
            },
            {
                title: 'Custom Bill',
                icon: <NotePencil size={30} weight="duotone" />,
                link: '/CustomBill'
            },
            {
                title: 'Payment',
                icon: <CreditCard size={30} weight="duotone" />,
                link: '/CustomBill'
            },
            {
                title: 'Reciepts',
                icon: <Receipt size={30} weight="duotone" />,
                link: '/CustomBill'
            },
        ]
    },
    {
        title: 'Querys',
        icon: <ChatDots size={30} weight="duotone" />,
        link: '/Querys',
    },
    {
        title: 'Registration',
        icon: <UsersThree size={30} weight="duotone" />,
        link: '/Registration',
    },
]


export default SidebarApi